import React from 'react';
import { Page } from '../Page';
import { Beef, Leaf, Wheat, Utensils, SlidersHorizontal, CheckCircle2, TrendingUp, Info } from 'lucide-react';
export function Page5() {
  return <Page pageNumber={23} variant="light" data-id="element-921" data-mp="2nd37oxb7kzdr">
      <div className="flex flex-col h-full" data-id="element-922" data-mp="2neellpydbnil">
        <div className="mb-6 pt-2" data-id="element-923" data-mp="2reyhkq77gl35">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-924" data-mp="2rdwvlqonie6n">
            The Essentials
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-925" data-mp="1urab55giagzf">
            How to <span className="text-tealslate" data-id="element-926" data-mp="1zq4t656ng1ih">Plate a Meal</span>
          </h1>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-927" data-mp="23o2id80f6nlv">
            When you don't want to track numbers, use the plate method.
          </p>
        </div>

        {/* Plate diagram on light bg */}
        <div className="flex justify-center items-center mb-6" data-id="element-928" data-mp="3f498lfyr7143">
          <div className="w-[140px] space-y-4 text-right pr-4" data-id="element-929" data-mp="3k32qrlozjgal">
            <div data-id="element-930" data-mp="3k5otn80xl7mh">
              <h3 className="text-tealslate font-bold text-xs uppercase tracking-wider" data-id="element-931" data-mp="9bouk50w1qvr">
                Protein
              </h3>
              <p className="text-[9px] text-[#7A7A70]" data-id="element-932" data-mp="4e6smylagbx9">
                Chicken, fish, eggs, tofu, lean beef
              </p>
            </div>
          </div>

          <div className="w-[260px] h-[260px] rounded-full shadow-lg relative border-[6px] border-[#D8D8D0] shrink-0" style={{
          background: 'conic-gradient(from 270deg, #8FADB8 0deg 180deg, #B8C5B4 180deg 270deg, #D4C9A8 270deg 360deg)'
        }} data-id="element-933" data-mp="3qkc19cc7fm5g">
            <div className="absolute inset-3 rounded-full border border-white/40 pointer-events-none" data-id="element-934" data-mp="3crvvw4vtzc1d" />
            <div className="absolute top-0 bottom-0 left-1/2 w-px bg-white/50 -translate-x-1/2" data-id="element-935" data-mp="37udm6c9zossb" />
            <div className="absolute top-1/2 bottom-0 left-1/2 right-0 h-px bg-white/50 -translate-y-1/2" data-id="element-936" data-mp="32ur6zxalp2gv" />

            <div className="absolute top-0 bottom-0 left-0 w-1/2 flex flex-col items-center justify-center text-center" data-id="element-937" data-mp="2ytywz1twmtjj">
              <Beef className="w-7 h-7 text-white/90 mb-1" data-id="element-938" data-mp="2o6hdc6xy58d5" />
              <span className="text-2xl font-serif text-white font-bold" data-id="element-939" data-mp="2t75e3kbz93kk">
                1/2
              </span>
              <span className="text-[8px] font-bold text-white uppercase tracking-wider" data-id="element-940" data-mp="2f85n460zscl8">
                Protein
              </span>
            </div>
            <div className="absolute top-0 right-0 w-1/2 h-1/2 flex flex-col items-center justify-center text-center" data-id="element-941" data-mp="37vrt1kxoztb9">
              <Leaf className="w-5 h-5 text-white/90 mb-0.5" data-id="element-942" data-mp="3bxwkqe4kyfv9" />
              <span className="text-lg font-serif text-white font-bold" data-id="element-943" data-mp="3bzhcjvzifkpf">
                1/4
              </span>
              <span className="text-[7px] font-bold text-white uppercase" data-id="element-944" data-mp="33531k5m0iwc4">
                Veggies
              </span>
            </div>
            <div className="absolute bottom-0 right-0 w-1/2 h-1/2 flex flex-col items-center justify-center text-center" data-id="element-945" data-mp="3qudx98oia0je">
              <Wheat className="w-5 h-5 text-white/90 mb-0.5" data-id="element-946" data-mp="3vmx83xvt6hki" />
              <span className="text-lg font-serif text-white font-bold" data-id="element-947" data-mp="8u9z7r1h0bml">
                1/4
              </span>
              <span className="text-[7px] font-bold text-white uppercase" data-id="element-948" data-mp="4s55ytexph0h">
                Carbs
              </span>
            </div>
          </div>

          <div className="w-[140px] space-y-4 pl-4" data-id="element-949" data-mp="imflck51jytv">
            <div data-id="element-950" data-mp="dmt9ae0y8omn">
              <h3 className="text-tealslate font-bold text-xs uppercase tracking-wider" data-id="element-951" data-mp="dma2ntgr1mnx">
                Vegetables
              </h3>
              <p className="text-[9px] text-[#7A7A70]" data-id="element-952" data-mp="3hzq4guecvpw2">
                Leafy greens, broccoli, peppers
              </p>
            </div>
            <div data-id="element-953" data-mp="3w0ix19l3kawj">
              <h3 className="text-tealslate font-bold text-xs uppercase tracking-wider" data-id="element-954" data-mp="3w12hoy24tde9">
                Carbs
              </h3>
              <p className="text-[9px] text-[#7A7A70]" data-id="element-955" data-mp="3r2r7gm7xd0vi">
                Brown rice, quinoa, sweet potato
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-956" data-mp="169npgyqqh1ub">
          <Info className="w-3.5 h-3.5 text-tealslate" data-id="element-957" data-mp="3bz97dy6cezv4" />
          <p className="text-[10px] text-[#7A7A70]" data-id="element-958" data-mp="3c0ssc22y1z38">
            <strong className="text-[#3B3B3B]" data-id="element-959" data-mp="3gyc48vc65zs0">Note:</strong> Starchy vegetables
            count in the carbohydrate category.
          </p>
        </div>

        {/* Quick Tips */}
        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-960" data-mp="3pyhc16l9z06p">
          <h3 className="text-center text-[10px] font-bold text-tealslate uppercase tracking-[0.15em] mb-3" data-id="element-961" data-mp="3uxbs40ruyan4">
            Quick Tips
          </h3>
          <div className="grid grid-cols-4 gap-3" data-id="element-962" data-mp="3ppv2qzn96f8">
            {[{
            icon: Utensils,
            text: 'Eat protein first'
          }, {
            icon: SlidersHorizontal,
            text: 'Adjust portions to goals'
          }, {
            icon: CheckCircle2,
            text: 'Keep it simple'
          }, {
            icon: TrendingUp,
            text: 'Progress over perfection'
          }].map((tip, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-963" data-mp="220q1ssgbg9g5" data-mpi={i}>
                <div className="w-8 h-8 rounded-full bg-tealslate/20 flex items-center justify-center mb-2" data-id="element-964" data-mp="222t1k479tgy2">
                  <tip.icon className="w-4 h-4 text-tealslate" data-id="element-965" data-mp="1szrw85q8btvg" />
                </div>
                <p className="text-[9px] text-[#3B3B3B] font-medium leading-tight" data-id="element-966" data-mp="1t24lz528b8j2">
                  {tip.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </Page>;
}